<template>
	<g :transform="translate" :opacity="opacity">
		<path :d="innerD" class="inner" :fill="color"></path>
		<path :d="outerD" class="outer" :stroke="color" ref="outer" vector-effect="non-scaling-stroke" :style="styles"></path>
	</g>
</template>

<script>
	import * as d3 from "d3";

	export default {
		name: "TracePoint",
		props: {
			pos: {},
			opacity: {
				default: 1,
			},
			symbol: {
				default: d3.symbolSquare,
			},
			color: {
				default: "#ffffff",
			}
		},
		data() {
			return {
				styles: {},
			}
		},
		computed: {
			innerD: function () {
				return d3.symbol().type(this.symbol).size(20)();
			},
			outerD: function () {
				return d3.symbol().type(this.symbol).size(40)();
			},
			translate: function () {
				return "translate(" + this.pos[0] + " " + this.pos[1] + ")";
			},
		},
		mounted() {
			if (this.symbol !== d3.symbolCircle) {
				return
			}
			this.styles = {
				"stroke-dashoffset": -3,
				"stroke-dasharray": this.$refs.outer.getTotalLength() / 4,
			};
		},
	}
</script>

<style scoped>
	@keyframes expand {
		from {
			transform: scale(1.0);
		}
		to {
			transform: scale(2.0);
		}
	}

	.inner {
		/*fill: #ff0000;*/
	}

	.outer {
		animation-name: expand;
		animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
		animation-duration: 0.3s;
		transform: scale(2.0);
		/*stroke: #ff0000;*/
		stroke-width: 2;
		stroke-linecap: round;
		fill: none;
	}
</style>